module.exports = __webpack_public_path__ + "img/wdrq4.e47b8cfe.png";